import { Grid, Typography } from '@material-ui/core';
import { UploadDocumentCredenciado, CredenciadoEmissorRequest, CredenciadoDocumentRequest } from 'common/genericTypes';
import { CpfCnpjMask } from 'components/masks';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { Button, Dropdown, LgSpace, TextField, MdSpace, Section } from 'm2m.components';
import React, { useState } from 'react';
import { sanitizeAlphanumericCnpj } from 'utils/cnpjUtils';
import { validaCpfCnpj, stripCpfCnpjFormatting } from 'utils/validation';
import { documentShortDescriptions, documentLongDescriptions } from 'common/genericDescriptions';
import { Option } from 'common/genericOptions';
import { RootState } from 'store/index';
import { useDispatch, useSelector } from 'react-redux';
import { addAlert } from 'store/modules/snackBar';

export const CredenciadosEmissor: React.FC = (props) => {
  const [cnpjEmissor, setCnpjEmissor] = useState<string>();
  const [isCnpjValid, setIsCnpjValid] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [uploadDocumentType, setUploadDocumentType] = useState<string>('');
  const [documents, setDocuments] = useState<Array<Attachment>>([]);
  const [attachments, setAttachments] = useState<Array<CredenciadoDocumentRequest>>([]);
  const [documentOptions] = useState<Option[]>([
    {
      value: UploadDocumentCredenciado.Credenciado,
      description: documentShortDescriptions[UploadDocumentCredenciado.Credenciado],
    },
  ]);
  const credenciadoApi = useSelector((state: RootState) => state.credenciadoApi);
  const dispatch = useDispatch();

  const handleCnpjChange = (value: string) => {
    const clean = sanitizeAlphanumericCnpj(value);
    setCnpjEmissor(clean);
    if (validaCpfCnpj(clean)) {
      setIsCnpjValid(true);
      setError(false);
      return;
    } else {
      setIsCnpjValid(false);
      setError(clean.length === 14);
    }
  };

  const handleUpdateFile = (attachments: Attachment[]) => {
    const updatedAttachments = documents.concat(attachments);
    setDocuments(updatedAttachments);
  };

  const handleDeleteFile = async (type: string) => {
    const updatedAttachments = documents.filter((anexo) => anexo.id !== type);
    setDocuments(updatedAttachments);
  };

  const handleSubmit = async () => {
    setAttachments([]);
    documents.forEach((document) => {
      attachments.push({ file: document.file, emissionType: uploadDocumentType });
    });

    try {
      const result = await credenciadoApi.postCredenciadoEmissor(
        dispatch,
        { cnpjEmissor: cnpjEmissor, attachments: attachments } as CredenciadoEmissorRequest,
        true
      );
      dispatch(addAlert({ message: result.message, severity: 'success' }));
    } catch (error) {}
  };

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Solicitação de credenciamento'}</Typography>
      </Grid>
      <LgSpace />
      <>
        <Section title={'Dados emissor'}>
          <Grid container justify="center">
            <Grid item sm={6}>
              <TextField
                label="Informe o CNPJ do Emissor:"
                value={CpfCnpjMask(cnpjEmissor ?? '')}
                onChange={handleCnpjChange}
                error={error}
                errorMessage={`Informe um CNPJ válido`}
              />
            </Grid>
          </Grid>
        </Section>
        <Section title={'Comprovantes'}>
          <Grid container justify="center">
            <Grid item sm={6}>
              <Dropdown
                label={'Selecione o tipo do documento'}
                options={documentOptions}
                value={uploadDocumentType ?? ''}
                onChange={setUploadDocumentType}
              />
            </Grid>
            <LgSpace />
            <Grid item sm={12}>
              <UploadDocs onChange={handleUpdateFile} onDelete={handleDeleteFile} multipleFiles />
            </Grid>

            <Grid item xs={12}>
              {documents?.map((document) => (
                <React.Fragment key={document.id}>
                  <Grid container spacing={1}>
                    <Grid item></Grid>
                    <Grid item xs>
                      <Typography variant="body2">{documentLongDescriptions[document.id]}</Typography>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </Section>

        <Grid container justify="center">
          <Grid item>
            <Button disabled={!isCnpjValid} variant="contained" color="primary" onClick={handleSubmit}>
              {'Solicitar credenciamento'}
            </Button>
            <MdSpace />
          </Grid>
        </Grid>
      </>
    </div>
  );
};

export default CredenciadosEmissor;
